import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowLeft, FiChevronRight, FiX } from "react-icons/fi";
import "./MobileNav.css";

const menuItems = [
  { id: "about", key: "aboutUs", hasChildren: true },
  { id: "products", key: "products", to: "/products" },
  { id: "solutions", key: "solutions", to: "/allsolutions" },
  { id: "services", key: "services", to: "/services" },
  { id: "sectors", key: "sectors", to: "/sectors" },
  { id: "projects", key: "projects", to: "/allprojects" },
  { id: "estimator", key: "estimator", to: "/estimator" },
];

const aboutLinks = [
  { label: "WHO WE ARE", to: "/about", highlight: true },
  { label: "ACADEMY", to: "/academy" },
  { label: "CAREERS", to: "/careers" },
  { label: "DOWNLOADS", to: "/downloads" },
  { label: "BLOG", to: "/blog" },
  { label: "CONTACT US", to: "/contactus" },
];

const MobileNav = ({ isOpen, onClose, onRequestCall, t, i18n }) => {
  const [activeMenu, setActiveMenu] = useState("main");

  useEffect(() => {
    if (!isOpen) {
      setActiveMenu("main");
    }
  }, [isOpen]);

  return (
    <div className={`mobile-nav ${isOpen ? "mobile-nav--open" : ""}`}>
      <div className="mobile-nav__top">
        {activeMenu === "main" ? (
          <h2>{t("navbar.menu")}</h2>
        ) : (
          <button
            type="button"
            className="mobile-nav__back"
            onClick={() => setActiveMenu("main")}
          >
            <FiArrowLeft />
            <span>{activeMenu === "about" ? t("navbar.aboutUs") : t("navbar.menu")}</span>
          </button>
        )}

        <button
          type="button"
          className="mobile-nav__close"
          onClick={onClose}
          aria-label="Close mobile menu"
        >
          <FiX />
        </button>
      </div>

      {activeMenu === "main" ? (
        <ul className="mobile-nav__links">
          {menuItems.map((item) => (
            <li key={item.id}>
              {item.hasChildren && item.id === "about" ? (
                <button
                  type="button"
                  className="mobile-nav__itemButton"
                  onClick={() => setActiveMenu("about")}
                >
                  <span>{t(`navbar.${item.key}`)}</span>
                  <FiChevronRight className="mobile-nav__icon" />
                </button>
              ) : item.to ? (
                <Link to={item.to} onClick={onClose} className="mobile-nav__itemLink">
                  <span>{t(`navbar.${item.key}`)}</span>
                  {item.hasChildren && <FiChevronRight className="mobile-nav__icon" />}
                </Link>
              ) : (
                <button type="button" className="mobile-nav__itemButton">
                  <span>{t(`navbar.${item.key}`)}</span>
                  {item.hasChildren && <FiChevronRight className="mobile-nav__icon" />}
                </button>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <ul className="mobile-nav__links mobile-nav__links--submenu">
          {aboutLinks.map((item) => (
            <li key={item.label}>
              <Link
                to={item.to}
                onClick={onClose}
                className={`mobile-nav__subLink ${item.highlight ? "is-highlight" : ""}`}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      )}

      <div className="mobile-nav__bottom">
        <div className="mobile-nav__languageTabs">
          {["en", "ar", "ku"].map((lang) => (
            <button
              type="button"
              key={lang}
              className={i18n.language === lang ? "is-active" : ""}
              onClick={() => {
                i18n.changeLanguage(lang);
                localStorage.setItem("irqgyp_lang", lang);
              }}
            >
              {lang.toUpperCase()}
            </button>
          ))}
        </div>
        <button className="buttongyp mobile-nav__requestBtn" onClick={onRequestCall}>
          {t("navbar.requestCall")}
        </button>
      </div>
    </div>
  );
};

export default MobileNav;
